var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDetails',{attrs:{"data":_vm.store,"loading":_vm.storeLoading,"get-function":_vm.getStore}},[(_vm.store)?_c('StoreForm',{attrs:{"title":_vm.$t('store.edit_btn'),"model":_vm.store,"action":_vm.editStore},on:{"success":_vm.handleSuccess}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }